export const splitAndFilterString = (input) => {
  if (!input) {
    return '';
  }

  const parts = input.split('|');
  const filteredParts = parts.filter((part) => part.trim() !== '');
  return filteredParts.join(', ');
};
